import { createStore } from "vuex";

import applicationProp from "./modules/application-prop";
import regions from "./modules/regions";
import countries from "./modules/countries";
import cockpitstate from "./modules/cockpitstate";
import notifications from "./modules/notifications";
import manageSubcriptions from "./modules/manage-subcriptions";

const debug = process.env.NODE_ENV !== "production";
//todo check this
export default createStore({
  modules: {
    applicationProp,
    regions,
    countries,
    cockpitstate,
    notifications,
    manageSubcriptions,
  },
  strict: debug,
  plugins: [],
});
